import { createI18n } from 'vue-i18n'

import { es } from '@/locales/es'

/**
 * The interface is Spanish-only today. vue-i18n is used anyway because it
 * gives pluralization, date and number formatting for the locale, and it
 * enforces the rule that no Spanish string is written inside a component.
 */
export const i18n = createI18n({
  // Composition API mode. The Options API `$t` is not used anywhere.
  legacy: false,
  locale: 'es-MX',
  fallbackLocale: 'es-MX',
  messages: {
    'es-MX': es,
  },
  // Currency and dates follow Mexican conventions: $ and dd/mm/yyyy.
  numberFormats: {
    'es-MX': {
      currency: {
        style: 'currency',
        currency: 'MXN',
        currencyDisplay: 'narrowSymbol',
        maximumFractionDigits: 0,
      },
      area: {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      },
      count: {
        style: 'decimal',
        maximumFractionDigits: 0,
      },
    },
  },
  datetimeFormats: {
    'es-MX': {
      short: { day: '2-digit', month: '2-digit', year: 'numeric' },
      long: { day: '2-digit', month: 'long', year: 'numeric', hour: '2-digit', minute: '2-digit' },
    },
  },
})
